import React, { useState } from 'react';
import { Layout, Row, Col, Select, Switch } from 'antd';
import CButton from '../../../component/Button';
import GlobusLogo from '../../../asset/globus-logo.svg';
import InfoBtn from '../../../asset/info.svg';
import './CartOptionStyle.css';

const options = [
  { name: 'Domain Privacy Protection', price: '2.99' },
  { name: 'Auto Renew', price: '2.99' },
  { name: 'Third Service', price: '3.99' }
];

const CartOption = ({ name, price }) => {
  const [select, setSelect] = useState(false);

  return (
    <Row
      style={{
        justifyContent: 'space-between',
        margin: '17px 30px 17px 30px',
        width: '100%'
      }}
    >
      <Col>
        {name} is <b>{select ? 'ON ' : 'OFF '}</b>
        <img alt="information" src={InfoBtn} />
      </Col>
      <Col>
        <Row>
          <Col className={select ? '' : 'strikethrough'} style={{ marginRight: '30px' }}>
            {`$${price}`}/mo
          </Col>
          <Col>
            <Switch checked={select} defaultChecked onChange={setSelect} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const CartOptions = () => {
  return (
    <Layout
      style={{
        backgroundColor: '#F0F4FF',
        borderRadius: '10px',
        marginLeft: '34px',
        width: '744px'
      }}
    >
      <Row
        style={{
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '30px 30px 30px 30px'
        }}
      >
        <Col style={{ fontWeight: 'bold', textAlign: 'center' }}>
          <img alt="globus logo" src={GlobusLogo} /> Noxtton.biz
        </Col>
        <Col>
          <Select
            defaultValue="1 Year"
            style={{ height: '40px', textAlign: 'start', width: '136px' }}
          />
        </Col>
        <Col style={{ fontSize: '18px' }}>
          <b>$7.99</b>/mo
        </Col>
        <Col>
          <CButton type="cartBtn">Remove</CButton>
        </Col>
      </Row>
      <hr
        style={{
          backgroundColor: '#CAD8FF',
          border: '1px solid #CAD8FF',
          width: '100%'
        }}
      />

      {options.map((i, index) => {
        return (
          <Row key={index}>
            <CartOption name={i.name} price={i.price} />
            {options.indexOf(i) === options.length - 1 ? (
              ''
            ) : (
              <hr
                style={{
                  backgroundColor: '#CAD8FF',
                  border: '1px solid #CAD8FF',
                  width: '95%'
                }}
              />
            )}
          </Row>
        );
      })}
    </Layout>
  );
};

export default CartOptions;
